// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyleguideComponent from "@store/Library/Components/Toolkit/Styleguide";
import * as React from "react";

const StyleguideTest: React.FunctionComponent<WidgetProps> = props => <StyleguideComponent />;

const widgetModule: WidgetModule = {
    component: StyleguideTest,
    definition: {
        group: "Basic",
        icon: "table-layout",
    },
};

export default widgetModule;
